import { storeApi } from '../services/api';

/**
 * StoreId를 가져옵니다.
 * 1. localStorage에서 조회
 * 2. JWT 토큰에서 추출
 * 3. 실패 시 0 반환
 */
export const getStoreId = (): number => {
  try {
    // 1. localStorage에서 조회
    const storeIdFromStorage = localStorage.getItem('storeId');
    if (storeIdFromStorage) {
      const parsedStoreId = parseInt(storeIdFromStorage, 10);
      if (!isNaN(parsedStoreId) && parsedStoreId > 0) {
        return parsedStoreId;
      }
    }

    // 2. JWT 토큰에서 추출
    const token = localStorage.getItem('token');
    if (token) {
      try {
        const payload = JSON.parse(atob(token.split('.')[1]));
        if (payload.storeId) {
          const parsedStoreId = parseInt(payload.storeId, 10);
          if (!isNaN(parsedStoreId) && parsedStoreId > 0) {
            return parsedStoreId;
          }
        }
      } catch (e) {
        // 토큰 파싱 실패는 무시
      }
    }
  } catch (error) {
    console.warn('⚠️ [StoreHelper] StoreId 조회 실패:', error);
  }

  return 0;
};

/**
 * StoreName을 가져옵니다.
 * 1. localStorage에서 조회
 * 2. API를 통해 조회 (StoreId가 있는 경우)
 * 3. 실패 시 null 반환
 */
export const getStoreName = async (): Promise<string | null> => {
  try {
    // 1. localStorage에서 조회
    const storeNameFromStorage = localStorage.getItem('storeName');
    if (storeNameFromStorage) {
      return storeNameFromStorage;
    }

    // 2. API를 통해 조회
    const storeId = getStoreId();
    if (storeId > 0) {
      try {
        const response = await storeApi.getStoreInfo(storeId);
        if (response.data?.name) {
          // localStorage에 저장 (다음 조회 시 빠른 접근)
          localStorage.setItem('storeName', response.data.name);
          return response.data.name;
        }
      } catch (error) {
        // API 조회 실패는 무시 (StoreId만 있어도 클릭 로그 저장 가능)
        console.warn('⚠️ [StoreHelper] StoreName API 조회 실패:', error);
      }
    }
  } catch (error) {
    console.warn('⚠️ [StoreHelper] StoreName 조회 실패:', error);
  }

  return null;
};
